import React from 'react'
import { Container, Grid, Col, Text, Paper, Table } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const RolesAndResponsibilities = () => {
  const { lang } = useTranslation()
  return (
    <>
      {lang === 'en' ? (
        <Container size="lg">
          <Grid>
            <Col span={12}>
              <>
                <Text size="lg" weight={700} style={{ marginBottom: '1rem' }}>
                  Roles and Responsibilities Document
                </Text>
                <Text size="md" weight={500} style={{ marginBottom: '1rem' }}>
                  Working Hours:
                </Text>
                <Text style={{ marginBottom: '1rem' }}>
                  Sunday to Thursday, from 8 AM to 4 PM.
                </Text>
                <Text size="md" weight={500} style={{ marginBottom: '1rem' }}>
                  Location:
                </Text>
                <Text style={{ marginBottom: '1rem' }}>
                  Jeddah – Al-Baghdadiyah Al-Gharbiyah – Hail Street, near the
                  Ministry of Information.
                </Text>
                <Text size="md" weight={500} style={{ marginBottom: '1rem' }}>
                  Contact:
                </Text>
                <Text style={{ marginBottom: '1rem' }}>
                  You can reach out via the contact form available at:{' '}
                  <a href="Contact Form">Contact Form</a>
                </Text>
                <Text size="lg" weight={700} style={{ marginBottom: '1rem' }}>
                  Departments and Their Roles:
                </Text>
                <Table>
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Department</th>
                      <th>Roles and Responsibilities</th>
                      <th>Contact Information</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Administrative Team</td>
                      <td>
                        Oversee site procedures, supervise the training process,
                        provide guidance and support to all parties involved in
                        the educational process, and evaluate the performance of
                        trainers and trainees.
                      </td>
                      <td>info@infinity.edu.sa</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Technical Support Team</td>
                      <td>
                        Address and resolve trainee issues, coordinate with
                        trainers and trainees, communicate with all parties, and
                        provide appropriate support.
                      </td>
                      <td>rabab@infinity.edu.sa</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>General Coordinator</td>
                      <td>
                        Develop strategies for trainers' workflow and training
                        courses.
                      </td>
                      <td>salehmsallaf@gmail.com</td>
                    </tr>
                  </tbody>
                </Table>
                <Text style={{ marginTop: '1rem' }}>
                  By defining these roles and responsibilities, Infinity Health
                  Training Academy ensures high-quality performance in
                  e-learning and effective support for all parties involved in
                  the educational process.
                </Text>
              </>
            </Col>
          </Grid>
        </Container>
      ) : (
        <Container size="lg">
          <Grid>
            <Col span={12}>
              <>
                <Text size="lg" weight={700} style={{ marginBottom: '1rem' }}>
                  وثيقة الأدوار والمسؤوليات
                </Text>
                <Text size="md" weight={500} style={{ marginBottom: '1rem' }}>
                  ساعات العمل:
                </Text>
                <Text style={{ marginBottom: '1rem' }}>
                  من الأحد إلى الخميس من الساعة 8 صباحاً إلى الساعة 4 مساءً.
                </Text>
                <Text size="md" weight={500} style={{ marginBottom: '1rem' }}>
                  الموقع:
                </Text>
                <Text style={{ marginBottom: '1rem' }}>
                  جدة – حي البغدادية الغربية – شارع حائل بقرب وزارة الإعلام.
                </Text>
                <Text size="md" weight={500} style={{ marginBottom: '1rem' }}>
                  وسائل التواصل:
                </Text>
                <Text style={{ marginBottom: '1rem' }}>
                  يمكن التواصل عن طريق نموذج التواصل معنا من خلال الاستبيان
                  التالي: <a href="نموذج التواصل">نموذج التواصل</a>
                </Text>
                <Text size="lg" weight={700} style={{ marginBottom: '1rem' }}>
                  الأقسام ودورهم ومسؤولياتهم:
                </Text>
                <Table>
                  <thead>
                    <tr>
                      <th>م</th>
                      <th>القسم</th>
                      <th>دور ومسؤوليات القسم المكلف بها</th>
                      <th>وسائل التواصل</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>الفريق الإداري</td>
                      <td>
                        متابعة إجراءات الموقع/ الإشراف على سير العملية التدريبية
                        وعلى العام التدريب والتوجيه والإرشاد لكافة أطراف العملية
                        التعليمية والقيام بأعمال المتابعة وتقييم أداء المدربين
                        والمتدربين
                      </td>
                      <td>info@infinity.edu.sa</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>الفريق الفني المساعد</td>
                      <td>
                        متابعة وحل مشاكل المتدربين/ التنسيق مع المدربين
                        والمتدربين والتواصل مع جميع الأطراف وتقديم الدعم المناسب
                      </td>
                      <td>rabab@infinity.edu.sa</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>المنسق العام</td>
                      <td>
                        تطوير استراتيجية سير عمل المدربين والدورات التدريبية
                      </td>
                      <td>salehmsallaf@gmail.com</td>
                    </tr>
                  </tbody>
                </Table>
                <Text style={{ marginTop: '1rem' }}>
                  بتنفيذ هذه الأدوار والمسؤوليات، تضمن أكاديمية إنفينيتي للتدريب
                  الصحي تحقيق أداء عالي الجودة في التعليم الإلكتروني ودعماً
                  فعالاً لكافة أطراف العملية التعليمية.
                </Text>
              </>
            </Col>
          </Grid>
        </Container>
      )}
    </>
  )
}

export default RolesAndResponsibilities
